"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentApiClient = void 0;
const models_1 = require("../../models");
class DocumentApiClient {
    constructor(_httpClient) {
        this._httpClient = _httpClient;
    }
    async generateInvoiceDocument(generateInvoiceRequest) {
        return (await this.generateDocument({
            ...generateInvoiceRequest,
            async: false,
        }));
    }
    async generateCarrierEarningsDocument(generateCarrierEarningsRequest) {
        return (await this.generateDocument({
            ...generateCarrierEarningsRequest,
            async: false,
        }));
    }
    async generateRateConfirmationDocuments(generateRateConfirmationsRequest) {
        return (await this.generateDocument({
            ...generateRateConfirmationsRequest,
            async: false,
        }));
    }
    async generateXPODeliveryReceiptDocument(generateXPODeliveryReceiptRequest) {
        return (await this.generateDocument({
            ...generateXPODeliveryReceiptRequest,
            async: false,
            template: models_1.DocumentTemplate.XPODeliveryReceipt,
        }));
    }
    async generateXPODeliveryReceiptDocumentAsync(generateXPODeliveryReceiptRequest) {
        return (await this.generateDocument({
            ...generateXPODeliveryReceiptRequest,
            async: true,
            template: models_1.DocumentTemplate.XPODeliveryReceipt,
        }));
    }
    async generateBillOfLading(generateBillOfLadingRequest) {
        return (await this.generateDocument({
            ...generateBillOfLadingRequest,
            async: false,
        }));
    }
    async generateShippingLabel(generateShippingLabelRequest) {
        return (await this.generateDocument({
            ...generateShippingLabelRequest,
            async: false,
        }));
    }
    /**
     * Generic method that can be used to generate a document
     * using any of the existing document-api templates.
     */
    async generateDocument(requestBody) {
        const response = await this._httpClient.request({
            data: requestBody,
            method: 'POST',
            url: '/',
        });
        return response.data;
    }
    async mergeFiles(mergeFilesRequest) {
        const response = await this._httpClient.request({
            data: mergeFilesRequest,
            method: 'POST',
            url: '/merge',
        });
        return response.data;
    }
    async convertDocument(documentConversionRequest) {
        const response = await this._httpClient.request({
            data: documentConversionRequest,
            method: 'POST',
            url: '/pipeline',
        });
        return response.data;
    }
    async convertDocumentSync(documentConversionRequest) {
        const response = await this._httpClient.request({
            data: documentConversionRequest,
            method: 'POST',
            url: '/conversion/sync',
        });
        return response.data;
    }
    async slicePdf(slicePdfRequest) {
        const response = await this._httpClient.request({
            data: slicePdfRequest,
            method: 'POST',
            url: '/modification/pdf/slice',
        });
        return response.data;
    }
}
exports.DocumentApiClient = DocumentApiClient;
//# sourceMappingURL=DocumentApiClient.js.map